import React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { ThemeProvider as EmotionThemeProvider } from '@emotion/react';
import { theme } from './theme/material';
export var ThemeProvider = function (_a) {
    var children = _a.children;
    return (React.createElement(MuiThemeProvider, { theme: theme },
        React.createElement(EmotionThemeProvider, { theme: theme },
            React.createElement(CssBaseline, null),
            children)));
};
